import { geti18n } from '../../utils';
import {
  GET_ALL_MODELLINES_FAILED,
  GET_DMA_FAILED,
  GET_MODEL_TRIMS_FAILED,
  GET_PAYMENT_OPTIONS_FAILED,
  LOCATION_CHANGING
} from '../constants';

const modelLineErrorMsg = geti18n('fetchErrors.modelLines');
const DMAErrorMsg = geti18n('fetchErrors.dma');
const trimErrorMsg = geti18n('fetchErrors.trim');
const paymentOptionErrorMsg = geti18n('fetchErrors.paymentOptions');

const initialState = {
  appHasError: false,
  errorTitle: 'Error',
  errorMsg: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case LOCATION_CHANGING: {
      return {
        ...state,
        appHasError: false,
      }
    }

    case GET_ALL_MODELLINES_FAILED: {
      return {
        ...state,
        errorMsg: modelLineErrorMsg,
        appHasError: true
      };
    }
    case GET_DMA_FAILED: {
      return {
        ...state,
        errorMsg: DMAErrorMsg,
        appHasError: true
      };
    }
    case GET_MODEL_TRIMS_FAILED: {
      return {
        ...state,
        errorMsg: trimErrorMsg,
        appHasError: true
      };
    }
    case GET_PAYMENT_OPTIONS_FAILED: {
      return {
        ...state,
        errorMsg: paymentOptionErrorMsg,
        appHasError: true
      };
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/errors.js
 **/